import Vue from 'vue'
import AppButton from 'components/AppButton'
import AppButtonPlus from 'components/AppButtonPlus'
import AppButtonDelete from 'components/AppButtonDelete'
import AppButtonMove from 'components/AppButtonMove'
import AppSelect from 'components/AppSelect'
import AppInput from 'components/AppInput'
import AppDatepicker from 'components/AppDatepicker'
import AppImage from 'components/AppImage'
import AppImageInput from 'components/AppImageInput'
import AppTextarea from 'components/AppTextarea'
import AppTimeSelect from 'components/AppTimeSelect'
import AppCheckbox from 'components/AppCheckbox'
import AppRadioButton from 'components/AppRadioButton'
import AppDateSince from 'components/AppDateSince'
import AppTable from 'components/AppTable'
import AppTableCell from 'components/AppTable/AppTableCell'
import AppTableColumn from 'components/AppTable/AppTableColumn'
import AppTablePagination from 'components/AppTable/AppTablePagination'
import AppTableRow from 'components/AppTable/AppTableRow'
import AppTableRowLoading from 'components/AppTable/AppTableRowLoading'
import AppTableHeader from 'components/AppTable/AppTableHeader'
import AppTableHeaderItem from 'components/AppTable/AppTableHeaderItem'
import AppTableHeaderSelect from 'components/AppTable/AppTableHeaderSelect'
import AppTableFooter from 'components/AppTable/AppTableFooter'
import AppContent from 'components/AppContent'
import AppContentTitle from 'components/AppContent/Title'
import AppContentBody from 'components/AppContent/AppContentBody'
import AppContentSaveButton from 'components/AppContent/SaveButton'
import AppContentNavLink from 'components/AppContent/NavLink'
import AppContentTopNav from 'components/AppContent/TopNav'
import AppSettings from 'components/AppSettings'
import AppSettingsContent from 'components/AppSettings/Content'
import AppSettingsButtons from 'components/AppSettings/Buttons'
import AppSettingsDesc from 'components/AppSettings/Desc'
import AppSettingsOptions from 'components/AppSettings/Options'
import AppSettingsInput from 'components/AppSettings/Input'
import AppSettingsControl from 'components/AppSettings/Control'
import AppSettingsCol from 'components/AppSettings/Col'
import AppSettingsSelect from 'components/AppSettings/Select'
import AppTabs from 'components/AppTabs'
import AppStatusIndicator from 'components/AppStatusIndicator'
import AppBooleanLiteral from 'components/AppBooleanLiteral'
import AppWrapperDiv from 'components/AppWrapperDiv'
import AppNotification from 'components/AppNotification'
import AppDeleteDialog from 'components/AppDeleteDialog'
import AppDeleteLabelDialog from './components/AppDeleteLabelDialog'
import AppGraphicImage from './components/AppGraphicImage'

Vue.component('app-button', AppButton)
Vue.component('app-button-plus', AppButtonPlus)
Vue.component('app-button-delete', AppButtonDelete)
Vue.component('app-button-move', AppButtonMove)
Vue.component('app-select', AppSelect)
Vue.component('app-input', AppInput)
Vue.component('app-image', AppImage)
Vue.component('app-image-input', AppImageInput)
Vue.component('app-textarea', AppTextarea)
Vue.component('app-time-select', AppTimeSelect)
Vue.component('app-checkbox', AppCheckbox)
Vue.component('app-radio-button', AppRadioButton)
Vue.component('app-date-since', AppDateSince)
Vue.component('app-datepicker', AppDatepicker)
Vue.component('app-graphic-image', AppGraphicImage)

Vue.component('app-table', AppTable)
Vue.component('app-table-cell', AppTableCell)
Vue.component('app-table-column', AppTableColumn)
Vue.component('app-table-pagination', AppTablePagination)
Vue.component('app-table-row', AppTableRow)
Vue.component('app-table-row-loading', AppTableRowLoading)
Vue.component('app-table-header', AppTableHeader)
Vue.component('app-table-header-item', AppTableHeaderItem)
Vue.component('app-table-header-select', AppTableHeaderSelect)
Vue.component('app-table-footer', AppTableFooter)

Vue.component('app-content', AppContent)
Vue.component('app-content-title', AppContentTitle)
Vue.component('app-content-body', AppContentBody)
Vue.component('app-content-save-button', AppContentSaveButton)
Vue.component('app-content-nav-link', AppContentNavLink)
Vue.component('app-content-top-nav', AppContentTopNav)

Vue.component('app-settings', AppSettings)
Vue.component('app-settings-content', AppSettingsContent)
Vue.component('app-settings-buttons', AppSettingsButtons)
Vue.component('app-settings-desc', AppSettingsDesc)
Vue.component('app-settings-options', AppSettingsOptions)
Vue.component('app-settings-input', AppSettingsInput)
Vue.component('app-settings-control', AppSettingsControl)
Vue.component('app-settings-col', AppSettingsCol)
Vue.component('app-settings-select', AppSettingsSelect)

Vue.component('app-tabs', AppTabs)

Vue.component('app-status-indicator', AppStatusIndicator)
Vue.component('app-boolean-literal', AppBooleanLiteral)
Vue.component('app-wrapper-div', AppWrapperDiv)
Vue.component('app-notification', AppNotification)
Vue.component('app-delete-dialog', AppDeleteDialog)
Vue.component('app-delete-label-dialog', AppDeleteLabelDialog)
